import httpManager from "@/app/shared/utils/httpManager";

/**
 * Elimina un alias "Enviar como" de un canal de correo.
 *
 * @param {number} channelCustomerId - ID del identificador de canal.
 * @param {number} id - ID del alias.
 * @param {boolean} confirm - Si es true, fuerza la eliminación aun si el alias fue usado.
 */
export default async function (channelCustomerId, id, confirm = false) {
  await httpManager.delete(
    `/channels/channel-customer/${channelCustomerId}/send-as-aliases/${id}/`,
    { confirm }
  );
}
